import React, { useState, useEffect } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ViewedExpandableTable.css";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import SvgSortdownarrow from "../../../../../Components/IconComponents/Sortdownarrow";
import SvgSortuparrow from "../../../../../Components/IconComponents/Sortuparrow";
import SvgSorting from "../../../../../Components/IconComponents/Sortingarrow";
import { executeSopContactList } from "../../../../../Services/EndPoints";
import { getDataById } from "../../../../../Services/Services"; 

// Static Data for Table Rows
const Data = [];

// Default filter UI for a column
const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // undefined to remove the filter entirely
      }}
      placeholder={`Filter...`}
      style={{
        width: "100%",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "5px",
      }}
    />
  );
};

const ViewedExecuteSopsExpandableTable = (props) => {
  const {
    columns,
    data,
    numberOfRows,
    headerTableHeadStyle = {},
    tableStyle = {},
    showRowCount = true,
    rowCount,
    setSearchData = () => {},
    enableColumnFilters = false,
    disbalePaginationFilter = false,
    disbalePaginationFilter1 = false,
    disbalePaginationFilter2 = false,
  } = props;

  const [expandedRowIds, setExpandedRowIds] = useState({});
  const [userTaskMap, setUserTaskMap] = useState([]);
  const toggleRowExpansion = (rowId) => {
    setExpandedRowIds((prev) => {
      const isCurrentlyExpanded = !!prev[rowId];
      return isCurrentlyExpanded ? {} : { [rowId]: true };
    });
  };

  const {
    getTableProps,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    rows,
    state: { pageIndex, globalFilter, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: numberOfRows },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { t } = useTranslation();

  const translateNumber = (number) => {
    const numberString = number.toString();
    return i18n.t(`numbers.${numberString}`, { defaultValue: numberString });
  };

  let tempRowCount = globalFilter ? rows.length : rowCount || data.length;
  let tempPageIndex = pageIndex;
  let tempPageSize = pageSize;

  if (tempPageIndex === undefined || tempPageIndex === null) {
    tempPageIndex = 0;
  }
  if (tempRowCount === undefined || tempRowCount === null) {
    tempRowCount = 0;
  }
  if (tempPageSize === undefined || tempPageSize === null) {
    tempPageSize = 10;
  }

  const startIndex = tempPageIndex * tempPageSize + 1 || 1;
  const endIndex =
    Math.min((tempPageIndex + 1) * tempPageSize, tempRowCount) || tempRowCount;

  const translatedStartIndex = startIndex;
  const translatedEndIndex = endIndex;
  const translatedRowCount = tempRowCount;

  useEffect(() => {
    setPageSize(numberOfRows);
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numberOfRows]);

  useEffect(() => {
    if (globalFilter) {
      const pageData = page?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    } else {
      const pageData = rows?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilter, rows]);
   
  const renderExpandedRow = (row) => {

    const getExecuteSopContactList = async () => {
      try {
        // Access the ID from the selected dataFromForm
        const executeSopContactListResponse = await getDataById(executeSopContactList, row.original.role);
        setUserTaskMap(executeSopContactListResponse);
      } catch (error) {
        console.error("Error fetching Execute SOP Contact List:", error);
      } finally {
        // Optionally handle post-fetch logic here
      }
    };
    getExecuteSopContactList();

    return (
      <tr>
        <td colSpan="6">
          <div style={{
            fontSize: "14pt",
            marginLeft: "0rem",
            marginTop: "0rem",
            marginBottom: "0rem",
          }}>Facility Contacts</div>
          <div
            style={{
              width: "85%",
              borderRadius: "10px",
              marginTop: "10px",
              marginLeft: "80px",
              marginBottom: "10px",
              border: "1px solid #ddd",
            }}
          >
            <table
              style={{
                height: "5%",
                borderCollapse: "collapse",
                position: "relative",
              }}
            >
              <thead style={{ position: "sticky" }}>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Name")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Email")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Phone")}
                  </th>              
                </tr>
              </thead>
              <tbody>
                {userTaskMap.map((task) => (
                  <tr key={task.id}>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {`${task.first_name} ${task.last_name || ""}`.trim() || t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.email || t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.phone_number || t("NA")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="tabl_container">
      <div style={{fontSize:"12pt",
        marginLeft: "1rem",
        marginTop: "1rem",
        marginBottom: "1rem",
      }}>Resouce List</div>
      <div className="viewed-sop-instance-table">
        <div class="row">
          <div class="col-sm">
            <div className="sopinstance_input_info">ID:</div>
          </div>
          <div class="col-sm">
            <div className="sopinstance_input_info">Name:</div>
          </div>
          <div class="col-sm">
            <div className="sopinstance_input_info">Total Quantity:</div>
          </div>
          <div class="col-sm">
            <div className="sopinstance_input_info">Available Quantity:</div>
          </div>
          <div class="col-sm">
            <div className="sopinstance_input_info"></div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm">
            <div><input type="text" value="" readOnly className="sopinstance_input" /></div>
          </div>
          <div class="col-sm">
            <div><input type="text" value="" readOnly className="sopinstance_input" /></div>
          </div>
          <div class="col-sm">
            <div><input type="text" value="" readOnly className="sopinstance_input" /></div>
          </div>
          <div class="col-sm">
            <div><input type="text" className="sopinstance_input" /></div>
          </div>
          <div class="col-sm">
            <button class="btn btn-deploy">Assign User Task</button>
          </div>
        </div>

      </div>

      <div className="iccc__table--container" style={tableStyle}>
        <table {...getTableProps()} className="table iccc--table">
          <thead>
            <tr>
              <th
                style={{
                  width: "30px",
                  textAlign: "left",
                  color: "white",
                  backgroundColor: "#1a7a73",
                }}
              >
                {t("")}
              </th>
              {headerGroups.map((headerGroup, index) => (
                <React.Fragment key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={headerTableHeadStyle}
                      key={index}
                    >
                      {column.render("Header")}
                      {!column.disableSortBy &&
                        (column.isSorted ? (
                          column.isSortedDesc ? (
                            <SvgSortdownarrow />
                          ) : (
                            <SvgSortuparrow />
                          )
                        ) : (
                        <SvgSorting />
                        ))}
                      {enableColumnFilters && column.canFilter && (
                        <div>{column.render("Filter")}</div>
                      )}
                    </th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>

<tbody>
        {Data.length > 0 ? (
          Data.map((row) => {
            const isExpanded = expandedRowIds[row.id];

            return (
              <React.Fragment key={row.id}>
                <tr>
                  <td style={{ textAlign: "left", cursor: "pointer"}} onClick={() => toggleRowExpansion(row.id)}>
                    {isExpanded ? "−" : "+"}
                  </td>
                  <td style={{ textAlign: "left", cursor: "pointer"}}>{row.id}</td>
                  <td style={{ textAlign: "left", cursor: "pointer"}}>{row.name}</td>
                  <td style={{ textAlign: "left", cursor: "pointer"}}>{row.status}</td>
                  <td style={{ textAlign: "left", cursor: "pointer"}}>{row.quantity}</td>
                  <td style={{ textAlign: "left", cursor: "pointer"}}>{row.action}</td>
                  <td style={{ textAlign: "left", cursor: "pointer"}}>{row.locationonmap}</td>
                </tr>
                {isExpanded && renderExpandedRow(row)}
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={4} className="no-data-text">
              No Data Found
            </td>
          </tr>
        )}
      </tbody>

        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center" style={{marginBottom:"3rem"}}>
        {!disbalePaginationFilter2 && (
          <div className="float-start m-2 mt-2 ms-3">
            {showRowCount && (
              <div className="float-start m-2 mt-1 ms-3 pagecount-style">
                {t("showingentriestable.showing")} {translatedStartIndex}{" "}
                {t("showingentriestable.to")} {translatedEndIndex}{" "}
                {t("showingentriestable.of")} {translatedRowCount}{" "}
                {t("showingentriestable.entries")}
              </div>
            )}
          </div>
        )}
        <div className="pagination">
          {!disbalePaginationFilter && (
            <div className="d-flex">
              <span className="pagination_gotopage">
                Go to Page:
                <input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(pageNumber);
                  }}
                  className="pagination_gotopage-input"
                />
              </span>
              <span>
                <select
                  className="pagination_select"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[10, 50, 100, 500, 1000, 2000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      show {pageSize}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          )}
          {!disbalePaginationFilter1 && (
            <>
              <button
                className="pagebtn mx-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>
              <button className="pagination_page">
                {translateNumber(pageIndex + 1)}{" "}
              </button>
              <button
                className="pagebtn"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <span className="right_pageno">
                {t("pagination.page_of", {
                  page: translateNumber(pageIndex + 1),
                  total: translateNumber(pageOptions.length),
                })}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewedExecuteSopsExpandableTable;
